<form nz-form [formGroup]="validateForm" class="ant-advanced-search-form" (keydown)="enterSubmit($event)">
  <div nz-row [nzGutter]="24">

    <ng-container *ngFor="let control of searchConfig">
      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="6"
        [ngClass]="{'display-none': control.type == 'hidden'}">
        <ng-container [ngSwitch]="control.type">
          <nz-form-item class="d-flex" *ngSwitchCase='"input"' nz-row>
            <nz-form-label nz-col nzSm="24" [nzMd]="labelSpan" [nzFor]="control.name">
              <ng-container *ngTemplateOutlet="internationalization; context:{name:control.nick}"></ng-container>
            </nz-form-label>
            <nz-form-control nz-col nzSm="24" [nzMd]="24 - labelSpan">
              <input nz-input [placeholder]="i18n?(control.placeholder | translate):control.placeholder" [formControlName]="control.name"
                [nzSize]="control.size || 'default'" [attr.id]="control.name" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="d-flex" *ngSwitchCase='"select"' nz-row>
            <nz-form-label nz-col nzSm="24" [nzMd]="labelSpan" [nzFor]="control.name">
              <ng-container *ngTemplateOutlet="internationalization; context:{name:control.nick}"></ng-container>
            </nz-form-label>
            <nz-form-control nz-col nzSm="24" [nzMd]="24 - labelSpan">
              <nz-select [formControlName]="control.name" [nzSize]="control.size || 'default'"
                [nzPlaceHolder]="i18n?(control.placeholder | translate):control.placeholder" nzAllowClear [attr.id]="control.name">
                <nz-option *ngFor="let item of control.data" [nzValue]="item.value + ''" [nzLabel]="item.label | translate">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <!-- <nz-form-item class="d-flex" *ngSwitchCase='"treeSelect"' nz-row>
            <nz-form-label nz-col nzSm="24" [nzMd]="labelSpan" [nzFor]="control.name">{{ control.nick }}</nz-form-label>
            <nz-form-control nz-col nzSm="24" [nzMd]="24 - labelSpan">
              <nz-tree-select [formControlName]="control.name"
                              [nzSize]="control.size || 'default'"
                              [nzPlaceHolder]="control.placeholder"
                              [nzAllowClear]="false"
                              [nzDefaultExpandAll]="false"
                              [nzMultiple]="getMultiple(control)"
                              nzShowSearch
                              [nzMaxTagCount]="control.maxTagCount"
                              [nzMaxTagPlaceholder]="omittedPlaceHolder"
                              [nzNodes]="control.data"
                              [attr.id]="control.name">
              </nz-tree-select>
            </nz-form-control>
          </nz-form-item> -->

          <nz-form-item class="d-flex" *ngSwitchCase='"timePiker"' nz-row>
            <nz-form-label nz-col nzSm="24" [nzMd]="labelSpan" [nzFor]="control.name" ngDefaultcontrol>
              <ng-container *ngTemplateOutlet="internationalization; context:{name:control.nick}"></ng-container>
            </nz-form-label>
            <nz-form-control nz-col nzSm="24" [nzMd]="24 - labelSpan">
              <nz-range-picker class="w-100p" [nzSize]="control.size || 'default'" [nzShowToday]="true"
                [formControlName]="control.name" [nzFormat]="control.dateFormat" [attr.id]="control.name"
                ngDefaultcontrol></nz-range-picker>
            </nz-form-control>
          </nz-form-item>

          <!-- <nz-form-item class="d-flex" *ngSwitchCase='"cascader"' nz-row>
            <nz-form-label nz-col nzSm="24" [nzMd]="labelSpan" [nzFor]="control.name" ngDefaultcontrol>{{ control.nick }}</nz-form-label>
            <nz-form-control nz-col nzSm="24" [nzMd]="24 - labelSpan">
              <nz-cascader class="w-100p" [nzSize]="control.size || 'default'" [formControlName]="control.name" [nzOptions]="control.data" [nzPlaceHolder]="control.placeholder" [nzChangeOnSelect]="control.nzChangeOnSelect">
              </nz-cascader>
            </nz-form-control>
          </nz-form-item> -->

          <!-- 隐藏的 -->
          <nz-form-item class="d-flex" *ngSwitchCase='"hidden"' nz-row>
            <nz-form-label nz-col nzSm="24" [nzMd]="labelSpan" [nzFor]="control.name">
              <ng-container *ngTemplateOutlet="internationalization; context:{name:control.nick}"></ng-container>
            </nz-form-label>
            <nz-form-control nz-col nzSm="24" [nzMd]="24 - labelSpan">
              <input nz-input [placeholder]="i18n?(control.placeholder | translate):control.placeholder" [nzSize]="control.size || 'default'"
                [formControlName]="control.name" [attr.id]="control.name" />
            </nz-form-control>
          </nz-form-item>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <div nz-row>
    <div nz-col [nzSpan]="24" style="text-align: right;">
      <ng-container *ngIf="i18n">
        <button nz-button class="mg-r-20" (click)="reset()">
          {{"common.reset" | translate}}
        </button>
        <button nz-button [nzType]="'primary'" (click)="search()">
          {{"common.search" | translate}}
        </button>
      </ng-container>
      <ng-container *ngIf="!i18n">
        <button nz-button class="mg-r-20" (click)="reset()">重置</button>
        <button nz-button [nzType]="'primary'" (click)="search()">搜索</button>
      </ng-container>
    </div>
  </div>
</form>


<!-- 国际化 -->
<ng-template #internationalization let-name="name">
  <ng-container *ngIf="name">
    {{ i18n ? (name | translate) : name}}
  </ng-container>
</ng-template>
